import { render, staticRenderFns } from "./temp-spinner.vue?vue&type=template&id=72b9acb5&scoped=true&"
import script from "./temp-spinner.vue?vue&type=script&lang=js&"
export * from "./temp-spinner.vue?vue&type=script&lang=js&"
import style0 from "./temp-spinner.vue?vue&type=style&index=0&id=72b9acb5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b9acb5",
  null
  
)

export default component.exports